import { useQuery } from '@tanstack/react-query';
import { useApi } from '@mainstage/core-plugin-api';
import { featureRequestRequesterApiRef } from '../../apis';
import { RequesterFeatureRequestFilters } from '@agilelab/plugin-wb-builder-common';

export const useFeatureRequestsByRequester = (
  filters: RequesterFeatureRequestFilters,
) => {
  const api = useApi(featureRequestRequesterApiRef);

  return useQuery({
    queryKey: ['feature-requests', 'by-requester', filters],
    queryFn: () => api.fetchByRequester(filters),
    staleTime: 5 * 60 * 1000,
  });
};
